module.exports = __webpack_public_path__ + "img/logout.5c3756ca.svg";